import { useNavigate } from 'react-router';
import { useSuspenseEndpointOIDCProviderQuery } from '#api/endpoint-oidc-providers.queries.ts';
import { useIsGoogleIdPProvider } from '#api/google-idp.queries.ts';
import { useSuspenseFeatureFlagsQuery } from '#api/org.queries.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { IdentityProviderFormWrapper } from '../../components/form/IdentityProviderFormWrapper.tsx';
import { GoogleDirectorySyncCard } from '../../google-idp/GoogleDirectorySyncCard.tsx';

type Props = {
  endpointOidcProviderId: string;
};

export function EditEndpointProvider({ endpointOidcProviderId }: Props) {
  const navigate = useNavigate();
  const location = useAppLocation();
  const {
    data: { data: endpointOIDC },
  } = useSuspenseEndpointOIDCProviderQuery(endpointOidcProviderId);
  const { data: { GOOGLE_IDP_SYNC } = {} } = useSuspenseFeatureFlagsQuery();
  const isGoogle = useIsGoogleIdPProvider(endpointOidcProviderId, { enabled: Boolean(GOOGLE_IDP_SYNC) });

  return (
    <MainLayout
      header={
        <PageHeader
          title={
            <>
              <Link to="/settings/sso?tab=endpoint" className="a">
                Single sign-on
              </Link>
              {' / '}
              <span>{endpointOIDC.name}</span>
            </>
          }
        />
      }
    >
      <Spacer direction="vertical" size="xxwide">
        <IdentityProviderFormWrapper
          id={endpointOidcProviderId}
          onClose={() => {
            void navigate(location.state?.from ?? '/settings/sso?tab=endpoint');
          }}
          adminIdentityProvider={null}
          endpointIdentityProvider={endpointOIDC}
        />
        {GOOGLE_IDP_SYNC && isGoogle ?
          <GoogleDirectorySyncCard endpointOIDC={endpointOIDC} />
        : null}
      </Spacer>
    </MainLayout>
  );
}
